'use client';

import type { NextPage } from 'next';
import Auth from '@/components/auth/Auth';
import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/navigation';
import { Suspense } from 'react';
import { Header } from '@/components/header/Header';

const LoginContent = () => {
  const params = useSearchParams();
  const router = useRouter();
  const defaultRole = 'client';

  const collectionAddress = params.get('collectionAddress');
  const affiliateId = params.get('affiliateId');
  const role = params.get('role') || defaultRole;

  return (
    <>
      <Header logoVariant='dark' />
      <div className='flex flex-col items-center min-h-screen py-2'>
        <div className='my-8 w-full max-w-md px-8 space-y-4'>
          <Auth
            role={role}
            collectionAddress={collectionAddress}
            affiliateId={affiliateId}
            onLoginSuccess={user => {
              const isMerchant = user?.roles?.includes('merchant');
              router.push(isMerchant ? '/dashboard/stories' : '/coupons');
            }}
          />
        </div>
      </div>
    </>
  );
};

const Page: NextPage = () => {
  return (
    <Suspense
      fallback={<div className='flex justify-center items-center min-h-screen'>Loading...</div>}
    >
      <LoginContent />
    </Suspense>
  );
};

export default Page;
